/**
 * Resolves whether the current user may edit/save on a Staff or Practitioner
 * edit page. Extracted so the core behavioural difference between the admin
 * edit path and Account Settings (self-edit) mode is unit-testable.
 *
 * Mirrors the Flutter save guard, which is `validatePermission([Manage_X],
 * edit:true) || isFromAccountSettings` on every tab
 * (staff_base_widget.dart:173,235,245; doctor_base_widget.dart:297,338,372,
 * 413,444,476,533). In account mode the user is editing their OWN record, so
 * the Manage_* permission is bypassed.
 *
 * Create mode always gates on the add permission (account mode never creates).
 */
export interface ResolveEditAllowedArgs {
  mode: 'create' | 'edit';
  accountMode: boolean;
  /** Has Manage_X { add: true } — only consulted in create mode. */
  canAdd: boolean;
  /** Has Manage_X { edit: true } — consulted in edit mode (admin path). */
  canEdit: boolean;
}

export function resolveEditAllowed({
  mode,
  accountMode,
  canAdd,
  canEdit,
}: ResolveEditAllowedArgs): boolean {
  if (mode === 'create') return canAdd;
  return accountMode || canEdit;
}
